import { Head, Link, useForm } from '@inertiajs/react';

import { Btn } from '@/Components/Btn';
import { PublicLayout } from '@/Layouts/PublicLayout';

type Props = {
    status?: string | null;
};

type FormShape = {
    email: string;
};

export default function MagicLink({ status }: Props) {
    const form = useForm<FormShape>({ email: '' });

    function submit(e: React.FormEvent) {
        e.preventDefault();
        form.post('/magic-link');
    }

    return (
        <PublicLayout>
            <Head title="Sign in with email link" />
            <div className="max-w-md mx-auto px-6 py-12">
                <h1 className="text-[32px] leading-tight text-ink mb-2">Sign in with email link</h1>
                <p className="text-[15px] text-ember mb-6">
                    We'll email you a one-time sign-in link. No password required.
                </p>

                {status && (
                    <div className="mb-4 text-[14px] text-emerald-700">{status}</div>
                )}

                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label htmlFor="magic-email" className="block text-[13px] uppercase tracking-wider text-ember mb-1">
                            Email
                        </label>
                        <input
                            id="magic-email"
                            type="email"
                            autoComplete="username"
                            required
                            value={form.data.email}
                            onChange={(e) => form.setData('email', e.target.value)}
                            className="w-full p-2 border border-rule rounded bg-card"
                        />
                        {form.errors.email && <p className="text-[12px] text-red-700 mt-1">{form.errors.email}</p>}
                    </div>

                    <Btn type="submit" full loading={form.processing}>
                        Send me a link
                    </Btn>

                    <div className="text-[13px] mt-4">
                        <Link href="/login" className="text-ember underline">Use password instead</Link>
                    </div>
                </form>
            </div>
        </PublicLayout>
    );
}
